module.exports = __webpack_public_path__ + "img/ws-people-engagement.4c35ad4e.png";